"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceAgreementStatus = exports.ServiceAgreementStatusLabels = exports.serviceAgreementStatuses = void 0;
const typebox_1 = require("@sinclair/typebox");
exports.serviceAgreementStatuses = ['DISABLED', 'NOT_SENT', 'PENDING', 'SIGNED'];
exports.ServiceAgreementStatusLabels = {
    DISABLED: 'Disabled',
    NOT_SENT: 'Not Sent',
    PENDING: 'Pending',
    SIGNED: 'Signed',
};
exports.ServiceAgreementStatus = typebox_1.Type.Union(exports.serviceAgreementStatuses.map((value) => typebox_1.Type.Literal(value)));
//# sourceMappingURL=service-agreement-status.js.map